module.exports = __webpack_public_path__ + "img/1251.d599931b.gif";